import React from 'react'

const Sathilaichithi = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. दिइएका अर्थसँग मिल्ने शब्द पाठबाट खोजेर लेख्नुहोस् :</h5>
        <p>(क) मलेसियाको मुद्रा : रिङ्गेट</p>
        <p>(ख) विदेश : परदेश</p>
        <p>(ग) नागरिक नभएको अवस्था : अनागरिक</p>
        <p>(घ) मर्न लागेकालाई बचाउने : मृतसञ्जीवनी</p>
        <p>(ङ) सफा : कञ्चन</p>
        <p>(च) उथलपुथल : उद्वेलित</p>
        <p>(छ) कार्य गर्ने क्षमता भएको : सामर्थ्य</p>
        <p>(ज) जन्मेको ठाउँ : जन्मथलो</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दहरुको अर्थ चिनेर जोडा मिलाउनु होस् :</h5>
        <p>(क) रहर : इच्छा , एक किसिमको दाल</p>
        <p>(ख) काम : कम्प , कार्य</p>
        <p>(ग) पत्र : चिठी , तह</p>
        <p>(घ) कडी : सानो कडा वा मुन्द्रो , जुक्ती</p>
        <p>(ङ) अन्तर : भिन्नता , भित्री हृदय</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका अनेकार्थी शब्दहरुको एकभन्दा बढी अर्थ लेख्नुहोस् :</h5>
        <p><strong>मास : </strong>माछाको मासु, विनाश वा क्षति </p>
        <p><strong>खरी : </strong>रौँ छुटाइएको बाख्राको छाला, कागज बनाउन प्रयोग हुने वस्तु</p>
        <p><strong>ताल : </strong>पानी जमेको स्थान, लय वा तालमेल </p>
        <p><strong>खाग : </strong>फलामको हतियार, विद्वान वा ज्ञानी व्यक्ति</p>
        <p><strong>फेरी : </strong>पुनः वा फेरि, यात्रा गर्न प्रयोग गरिने डुङ्गा</p>
        <p><strong>साँचो : </strong>ताला खोल्ने साधन, सत्य कुरा</p>
        <p><strong>कछाड : </strong>कम्मरसम्म उठाएर लगाइने लुगा, खोलाको किनार वा किनाराको खेत</p>
        <p><strong>अर्थ : </strong>कुनै शब्द वा वाक्यको मतलब, धन वा सम्पत्ति </p>
        <p><strong>चरण : </strong>खुट्टा वा पाइला, कुनै प्रक्रिया वा चरण</p>
        <p><strong>काल : </strong>मृत्यु या विनाश, समय वा अवधि</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका पदावलीलाई अर्थ स्पष्ट हुने गरी वाक्यमा प्रयोग गर्नुहोस् :</h5>
        <strong>कहाली लाग्नु</strong>
        <p>भूकम्प जाँदा पुरै गाउँमा भएको विनाश देखेर कहाली लाग्यो।</p>
        <strong>टपाटप टिप्नु</strong>
        <p>आमाले बारीमा पाकेका लिचीहरू टपाटप टिप्न थाल्नुभयो।</p>
        <strong>महिना मर्नु</strong>
        <p>विदेशमा पुगेको झन्डै एक वर्ष भइसक्यो, उसले त महिना मर्ने कुरै छैन।</p>
        <strong>रोइकराइ गर्नु</strong>
        <p>छोरा हराएपछि आमाले दिनरात रोइकराइ गरिरहनु भएको छ।</p>
        <strong>वितृष्णा पलाउनु</strong>
        <p>भ्रष्ट नेताहरूको व्यवहार देखेर युवामा राजनीतिप्रति वितृष्णा पलाएको छ।</p>
        <strong>हातमुख जोड्नु</strong>
        <p>आर्थिक अवस्था कमजोर भएपछि उसले मजदुरी गरेर हातमुख जोर्ने प्रयास गरिरहेको छ।</p>
        <strong>उजुरी गर्नु</strong>
        <p>छिमेकीले जबर्जस्ती जमिन अतिक्रमण गरेपछि बाबुले वडा कार्यालयमा उजुरी गर्नुभयो।</p>
        <strong>श्रम स्वीकृति लिनु</strong>
        <p>विदेश जानुअघि उसले श्रम कार्यालयबाट श्रम स्वीकृति लिएको थियो।</p>
        <strong>अवैधानिक</strong>
        <p>अवैधानिक रूपमा सीमा पार गर्दै गरेको व्यक्तिलाई सुरक्षाकर्मीले पक्राउ गरे।</p>
        <strong>बदला लिनु</strong>
        <p>उसले अपमान सहन नसकी बदला लिने योजना बनायो।</p>
        <strong>सहारा बन्नु</strong>
        <p>अपांग भएका बुवाको जीवनमा छोरा सहारा बनेको छ।</p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>(क) चिठीमा कतिवटा अनुच्छेद रहेका छन् ?</h5>
        <p>= चिठीमा सातवटा अनुच्छेद रहेका छन् ।</p>
        <h5>(ख) चिठीको आदि , मध्य र अन्त्य भागमा कस्ता विषयवस्तु छन् ?</h5>
        <p>= चिठीको आदि भागमा वैदेशिक रोजगारी प्रतिको मोह देखाइएको छ भने मध्य भागमा वैदेशिक रोजगारीले दिएको क्षणिक सुखको अनुभव सुनाइनुका साथै अन्त्य भागमा स्वदेश प्रतिको मोह देखाइएको छ ।</p>
        <h5>(ग) पुर्णविक्रमले सुरुका दुईतीन वर्ष विदेशमा कसरी बिताए ?</h5>
        <p>= पुर्णविक्रमले सुरुका दुईतीन वर्ष विदेशमा मोजमस्तीमा र रमाइलो गर्दै बिताए ।</p>
        <h5>(घ) पुर्णविक्रम कस्तो सपना बोकेर विदेश गएका थिए ?</h5>
        <p>= पुर्णविक्रम परदेशमा रहेको सुनको बोटबाट टपाटप पैसा टिपेर चाँडै धनी भइन्छ भन्ने सपना बोकेर विदेश गएका थिए ।</p>
        <h5>(ङ) चिठीमा के कस्ता अङ्गहरु हुन्छन् , लेख्नुहोस् ।</h5>
        <p>= चिठीमा मिति , ठेगाना, सम्बोधन , शिस्टाचार, विवरण, समापन र खामको नमुना जस्ता अङ्गहरु हुन्छन् ।</p>
      </div>
      <hr/>
      <div>
        <h5>२. `दिनहरु ……..हुने छु ', चिठीको अंश पढी खाली ठाउँमा छुटेका शब्द भर्नुहोस् :</h5>
        <p>(क) दुई महिनापछि काममा फर्कंदा <strong>कम्पनीले</strong> पनि राखेन ।</p>
        <p>(ख) त्यति वेला मात्र मलाई थाहा भयो, देश र परदेशको अन्तर ! नागरिक हुनु र <strong>अनागरिक</strong> हुनुको अन्तर !</p>
        <p>(ग) जीवनप्रति <strong>वितृष्णा</strong> पलाइरहेको थियो ।</p>
        <p>(घ) छिट्टै नेपाल फर्केर आफ्नै <strong>माटोमा</strong> परिश्रम गरी जीवन निर्वाह गर्ने विचारमा छु ।</p>
        <p>(ङ) अवको <strong>तीन महिनाभित्र</strong> म आफ्नो जन्मथलो, आफ्ना आमाबुबाको काख र प्रियजनहरुको माझमा हुने छु ।</p>
      </div>
      <hr/>
      <div>
        <h5>३. `अहिले म सम्झन्छु ………सार्थक बनाउँछु´ चिठीको अंश पढी दिइएका प्रश्नहरुको उत्तर लेख्नुहोस् :</h5>
        <h5>(क) नेपालको जलराशिमा कस्तो सामर्थ्य रहेको छ ?</h5>
        <p>= नेपालको जलराशिमा संसारकै मानिसहरुको प्यास मेटाउने सक्ने सामर्थ्य रहेको छ ।</p>
        <h5>(ख) हाम्रो देशको विकासले गति लिन नसक्नुको कारण के हो ?</h5>
        <p>= देशका जनताको दृढ इच्छाशक्ति र इमानदार प्रयत्न नभएकाले हाम्रो देशको विकासले गति लिन नसकेको हो ।</p>
        <h5>(ग) परदेशमा सिकेको सिपले कसरी देश विकास गर्न सकिन्छ ?</h5>
        <p>= परदेशमा सिकेको सिप आफ्नै देशमा प्रयोग गर्नुको साथै आरुलाई समेत सिकाई सोरोजगारको वातावारण सिर्जना गरेर देश विकास गर्न सकिन्छ ।</p>
        <h5>(घ) देश विकासको मूल मन्त्र के रहेछ ?</h5>
        <p>= देश विकासको मूल मन्त्र हरेक जनताले हातेमालो गर्दै अगाडि बढ्नुपर्छ रहेछ ।</p>
        <h5>(ङ) म पात्र किन घर फर्कन चाहेको हो ?</h5>
        <p>= वैदेशिक रोजगार प्रति वितृष्णा भएर म पात्र घर फर्कन चाहेको हो ।</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएको चिठीको अंश पढी प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) म पात्रले गरेका सही र गलत निर्णय के के थिए ?</h5>
        <p>= म पात्रले केही सही र केही गलत निर्णयहरू गरेका छन्। उनले वैदेशिक रोजगारी छोडेर आफ्ना गाउँ, परिवार र देश सम्झेर फर्कनु एउटा सही निर्णय थियो। विदेशमा रहँदा घरपरिवार र आफन्तलाई सम्झनु र उनीहरूकै माया र साथको खाँचो महसुस गर्नु उनको आत्मबोधको संकेत हो। तर, उनले केही गलत निर्णयहरू पनि गरेका छन्। पैसा कमाउने आशामा सोचविचार नगरी विदेशिनु, विदेशिएपछि आफ्ना परिवार र आफन्तलाई बिर्सनु, अनि कमाएको पैसाको उचित व्यवस्थापन नगरी फजुल खर्च गर्नु उनका प्रमुख गलत निर्णयहरू हुन्। यस्ता निर्णयहरूले उनलाई आर्थिक, सामाजिक र भावनात्मक रूपमै घाटा पुर्याएको देखिन्छ।</p>
        <h5>(ख) म पात्रको घर फर्कने निर्णयप्रति तपाईंको धारणा लेख्नुहोस् ।</h5>
        <p>= म पात्रको घर फर्कने निर्णयप्रति मेरो धारणा सकारात्मक छ। उनले वैदेशिक रोजगारीको मोह त्यागेर आफ्ना परिवार, गाउँ र देशप्रतिको माया देखाउँदै घर फर्कनु एक दूरदर्शी र जिम्मेवार निर्णय हो। आजको समयको सन्दर्भमा धेरै युवा विदेशी जीवनप्रति आकर्षित भएर देश छाड्न हतार गर्छन्, तर म पात्रको निर्णयले उनीहरूलाई पनि आत्ममूल्यांकन गर्न प्रेरणा दिन्छ। यस्तो निर्णयले गाउँ समाजलाई आफ्नै प्रयासले समृद्ध बनाउने सोच र देशप्रेमको भावना जागृत गराउँछ। म पात्रले आदर्शको बाटो रोजेर देखाएको उदाहरण युवाहरूका लागि प्रेरणादायी छ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. पुर्णविक्रमको ठाउँमा तपाईं हुनु भएको भए के गर्नुहुन्थ्यो , आफ्नो विचार प्रस्तुत गर्नुहोस् ।</h5>
        <p>यदि पूर्णविक्रमको ठाउँमा म भएको भए, म पनि पैसा कमाउने लोभमा परेर आफ्ना देश, परिवार र संस्कृतिलाई छाड्ने निर्णय गर्थिनँ। आफ्नो पढाइ पूरा गरेर म आफ्नै देशमा केही योगदान दिन चाहन्थें। स्वदेशमै अवसर खोजेर स्वरोजगारको बाटो रोज्थें र अरू युवाहरूलाई पनि यही मार्ग अपनाउन प्रेरित गर्थें। यदि परिस्थितिले बाध्य भएर विदेश जानै परेको भए पनि, म त्यहाँ केही समय मात्र बसेर अनुभव र पैसा संकलन गरेर स्वदेश फर्किन्थें। विदेशमा सिकेका सीप र ज्ञानलाई स्वदेशमै उपयोग गरेर देशको विकासमा सहयोग पुर्‍याउने प्रयास गर्थें। म देशलाई मात्र रोजगारीको स्रोत होइन, आफ्नो पहिचान र जिम्मेवारी ठानी स्वदेशमै केही असल काम गर्ने बाटो अपनाउने थिएँ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. तपाई सुरज हुनुभएको भए चिठीको प्रतिउत्तर कसरी दिनुहुन्थियो लेखनुहोस् :</h5>
        <p>मिति: २०७७।०१।२६</p><p>
स्थान: पोखरा, गण्डकी प्रदेश, नेपाल</p><p>

प्रिय मित्र पूर्णविक्रम,</p><p>
धेरै धेरै माया र मिठा सम्झनाहरू सहित !</p><p>

म यहाँ पूर्णतः कुशल छु। तपाईं पनि कुशलमंगल हुनुहुन्छ भन्ने गहिरो आशा गर्दछु।</p><p>
हजुरले पठाउनुभएको चिठी गत महिना प्राप्त गरें। चिठी पढेपछि म अत्यन्त हर्षित भएँ।</p><p>

केही समय बाटो बिराएका तपाईंको आँखामा अब चेतना आएको छ र भ्रमको पर्दा हटेको छ भन्ने कुरा सुनेर साँच्चै धेरै खुसी लाग्यो। तपाईंले विदेशमा सिक्नुभएको सीपहरू स्वदेशमै प्रयोग गर्ने विचार गर्नुभएको कुरा मलाई अत्यन्त मन पर्‍यो। तपाईं स्वदेश फर्कनुहोस्, म तपाईंलाई सक्दो आर्थिक सहयोग गर्नेछु।</p><p>

यहाँका युवाहरूलाई विदेशतिर आकर्षित हुनुको सट्टा स्वदेशमै केही गर्ने सोच दिन सक्नुभयो भने हाम्रो गाउँको चाँडै विकास हुनेछ। हामी मिलेर गाउँका युवालाई सीप सिकाउने र स्वरोजगारका नयाँ उपायहरू खोज्नेछौं।</p><p>

तपाईं स्वदेश फर्कनुहुने खबरले सम्पूर्ण गाउँवासी हर्षित भएका छन्। तपाईं कहिले आउनुहुन्छ र भेट हुने हो भन्ने उत्साहले म अधैर्य भइरहेको छु।</p><p>

ढिलै भए पनि तपाईंले यथार्थ बुझ्नुभएको र स्वदेशप्रतिको माया जाग्न गएको सुन्दा साँच्चिकै खुशी लाग्यो। विदेशमा भोग्नुपरेका दुःखद अनुभवहरू पनि मार्मिक छन्। तपाईंको घर फर्कने निर्णय अत्यन्तै स्वागतयोग्य छ।</p><p>

चिठी लामो हुँदै गइरहेको छ। बाँकी कुराहरू भेट हुँदा गरौंला। आजलाई यत्तिकै कलम बिसाउँछु।</p><p>

उही तपाईंको मित्र,</p><p>
सुरज नेपाल</p>
      </div>
      <hr/>
      <div>
        <h5>७. दिइएको अनुच्छेद पढ्नुहोस् र सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) मूल्याङ्कन भनेको के हो ?</h5>
        <p>= मूल्याङ्कन भनेको शैक्षिक उद्देश्यहरु कुन हदसम्म प्राप्त गर्न सकियो भनी किटान गर्ने प्रक्रिया भएकाले यो शिक्षण सिकाइको अभिन्न अङ्ग हो ।</p>
        <h5>(ख) निर्माणात्मक र निर्णयात्मक मुल्याङ्कन बिच के फरक छ?</h5>
        <p>= निर्माणात्मक मूल्याङ्कन कार्यक्रम सञ्चालन सँगसँगै औपचारिक र अनौपचारिक रुपमा जुनसुकै समयमा मूल्याङ्कन गरी पृष्ठपोषण दिन मिल्छ भने निर्णयात्मक मूल्याङ्कन शिक्षण सिकाइ कार्यक्रमको अन्त्यमा विद्यार्थीको उपलब्धि वा स्तर निर्धारण गरी प्रमाणपत्र प्रदान गरिन्छ । येही नै निर्माणात्मक र निर्णयात्मक मुल्याङ्कन बिच के फरक छ ।</p>
        <h5>(ग) प्रमाणपत्र दिने परीक्षा किन आवश्यक छ ?</h5>
        <p>= प्रमाणपत्र दिने परीक्षा शैक्षिक उद्देश्यबमोजिम विद्यार्थीले उपलब्धि हासिल गर्न सके वा नसकेको निर्णय लिई स्तर निर्धारण गरेर प्रमाणपत्र प्रदान दिन आवश्यक छ ।</p>
        <h5>(घ) `पाठ्यक्रम ´र `पृष्ठपोषण´ को अर्थ लेख्नुहोस् ।</h5>
        <p>= पाठ्यक्रम : शिक्षण सिकाइको पूर्ण योजनाको दस्तावेज
पृष्ठपोषण : कुनै काम कुरामा पछाडि बसेर सहायता पुर्‍याउने काम</p>
      </div>
      <div>
        <h5>८. गाउँको विकासका लागि पर्यावोरणमैत्री सडक आवसेक छ भन्ने खुलाउदै साथीलाई चिठी लेख्नुहोस् ।</h5>
        <p>मिति: २०७७।०१।२६</p><p>
स्थान: पोखरा, गण्डकी प्रदेश, नेपाल</p><p>

प्रिय साथी, अभिवादन!</p><p>

जीवनमा तिमीप्रति धेरै मिठा सम्झनाहरू छन्।</p><p>
म यहाँ सन्चै छु। तिमी र तिम्रो परिवार पनि सन्चै हुनुहुन्छ भन्ने शुभेक्षा गर्दछु।</p><p>
तिमीले पठाएको चिठी हिजो मात्र पाएँ। तिमीले गाउँको विकासका लागि पर्यावरणमैत्री सडकको आवश्यकता महसुस गरी सो विषयमा जान्न चाहेको कुरा पढेर एकदमै खुसी लाग्यो। यसै सन्दर्भमा म यो चिठी लेख्दैछु।</p><p>

वातावरण भनेको जैविक तथा अजैविक वस्तुहरूको सन्तुलित संयोजन हो, जसले मानिस, पशुपन्छी, रुखबिरुवा, माटो, पानी, हावा जस्ता तत्वहरूलाई सन्तुलनमा राख्दछ। हामीले विकासको नाममा वातावरणलाई नोक्सान पुर्‍याउने काम गर्नु हुँदैन।
गाउँमा सडक बनाउनु आवश्यक भए पनि त्यो सडकले वातावरणलाई असर नपार्ने गरी निर्माण गरिनु पर्छ। सडक निर्माणका क्रममा अनावश्यक रुख काट्नुहुँदैन, र यदि आवश्यक भयो भने सडक छेउमा नयाँ विरुवा रोपिनुपर्छ। बाटो वरपर फोहोर नगर्ने, धूलो नियन्त्रण गर्ने, ठूलो उद्योग वा मिल नखोल्ने जस्ता उपायहरूले वातावरणको सन्तुलन कायम राख्न सकिन्छ।</p><p>

धूलो, ध्वनि र फोहोरले वातावरण प्रदूषित हुन्छ र मानिसको स्वास्थ्यमा प्रतिकूल असर पर्छ। त्यसैले गाउँको विकास गर्दा सडक पनि वातावरणमैत्री ढङ्गले बन्नुपर्छ, जसले वातावरण जोगाउन सहयोग गर्छ र स्थानीय जीवनस्तर पनि सुधार हुन्छ।</p><p>

आजका लागि यत्तिकै। आशा छ, तिमीले पनि वातावरण जोगाउँदै विकास गर्ने आफ्ना विचार चिठीमा लेखेर पठाउने छौ। तिमीको जवाफ कुरिरहनेछु।</p><p>

तिमीकी सधैंकी साथी,</p><p>
नविना खड्का</p>
      </div>
      <hr/>
      <div>
        <h5>९. दिइएको अभिनन्दन पत्र पढ्नुहोस् र साहित्यका क्षेत्रमा योगदान गरेका कुनै एक व्यक्तिलाई प्रधान गरिने अभिनन्दन पत्रको नमुना तयार पार्नुहोस् :</h5>
        <p>अभिनन्दन पत्र</p><p>
श्री मोदनाथ प्रसृतज्यू</p><p>
काठमाडौँ, नेपाल</p><p>

विषय: साहित्यिक योगदानको उच्च सम्मान गर्दै अभिनन्दन।</p><p>

आदरणीय महोदय,</p><p>

नेपाली साहित्य क्षेत्रका प्रखर चिन्तक, सशक्त सर्जक तथा समाज परिवर्तनका संवाहक तपाईज्यूलाई हाम्रो संस्था सहमति हार्दिक अभिनन्दन अर्पण गर्दछ।</p><p>

तपाईंले दशौँ वर्षदेखि नेपाली साहित्यको उन्नयनका लागि पु¥याउनु भएको योगदान अतुलनीय छ। तपाईंका कविताहरू, निबन्धहरू, कथा–उपन्यासहरू तथा वैचारिक रचनाहरूले नेपाली भाषा, साहित्य र समाजलाई गहिरो प्रभाव पारेका छन्। साहित्यलाई चेतनाको माध्यम बनाउँदै समाज रूपान्तरणमा पु¥याउनुभएको प्रयास प्रशंसनीय र प्रेरणादायी छ।</p><p>

यस गौरवपूर्ण अवसरमा हामी संस्था सहमति तपाईंको योगदानप्रति उच्च सम्मान व्यक्त गर्दै यो अभिनन्दन पत्र प्रदान गर्दैछौँ।</p><p>

तपाईंको सृजनात्मक यात्रामा निरन्तर सफलता, उत्कृष्टता र दीर्घायूको शुभकामना व्यक्त गर्दछौं।</p><p>

जय साहित्य।</p><p>

शुभकामनासहित,</p><p>

संस्था: सहमति</p><p>
मिति: २०७२।०३।१८</p><p>
स्थान: भक्तपुर</p>
      </div>
      <hr/>
      <div>
        <h5>१०. सामाजिक क्षेत्रमा योगदान पुर्याउने कुनै एक व्यक्तित्वको योगदानको कदर गर्दै प्रदान गरिने सम्मान पत्रको नमुना तयार पार्नुहोस् :</h5>
        <p>सम्मान पत्र</p><p>
श्रीमती सेबिका पौडेल,</p><p>
चितवन</p><p>

विषय: सामाजिक क्षेत्रमा अतुलनीय योगदानको कदर गर्दै सम्मान।</p><p>

आदरणीय सेबिका पौडेलज्यू,</p><p>

हामी संस्था सहमति, तपाईंलाई सामाजिक क्षेत्रमा पुर्याउनुभएको समर्पित योगदानका लागि हार्दिक सम्मान व्यक्त गर्दछौं। तपाईंले चितवन जिल्लामा गरिरहनुभएको मानवसेवा, महिला सशक्तिकरण र सामुदायिक विकासका कार्यहरूले समाजलाई दिगो र समृद्ध बनाएको छ।</p><p>

तपाईंको निस्वार्थ प्रयासले विपन्न वर्गलाई राहत पुग्ने, शिक्षा तथा स्वास्थ्य क्षेत्रमा सकारात्मक प्रभाव पार्ने काम गरेको छ। यस्ता कार्यहरूले समग्र समाजमा सामाजिक न्याय र समानताको प्रवर्द्धन गर्न महत्वपूर्ण भूमिका खेलेको छ।</p><p>

यसै सन्दर्भमा संस्था सहमति ले तपाईंलाई यो सम्मान पत्र प्रदान गर्दै तपाईंको योगदानको उच्च कदर गर्दछ र आगामी दिनहरूमा थप सफलताको शुभकामना व्यक्त गर्दछ।</p><p>

धन्यवाद।</p><p>

शुभकामनासहित,</p><p>

संस्था: सहमति</p><p>
मिति: २०७१।०३।१८</p><p>
स्थान: चितवन</p>
      </div>
      <hr/>
      <div>
        <h5>व्याकरण</h5>
        <h5>१. दिइएको अनुच्छेद पढी कुन कुन लेख्य चिह्न प्रयोग भएका छन् , पहिचान गर्नुहोस् :</h5>
        <p>उद्धरण चिह्न</p>
        <p>अर्धविराम चिह्न</p>
        <p>विस्मयसूचक चिह्न</p>
        <p>अल्पविराम चिह्न</p>
        <p>प्रश्नचिह्न</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका वाक्यहरुमा आवश्यक ठाउँमा आवश्यक चिह्न प्रयोग गर्नुहोस् ।</h5>
        <h5>(क) मैले घर बाटो फूल मान्छे र गाडीहरुको चित्र बनाएको छु ।</h5>
        <p>= मैले घर, बाटो, फूल, मान्छे र गाडीहरुको चित्र बनाएको छु ।</p>
        <h5>(ख) तिमी यहाँ बस चकचक नगर</h5>
        <p>= तिमी यहाँ बस , चकचक नगर ।</p>
        <h5>(ग) हामीले सुखदुःख रातदिन जीवनमरण जस्ता आइरहने गइरहने कुरा हुन् भन्ने बुझ्नुपर्छ ।</h5>
        <p>= हामीले सुख-दुःख , रात-दिन , जीवन-मरणजस्ता आइरहने-गइरहने कुरा हुन् भन्ने बुझ्नुपर्छ ।</p>
        <h5>(घ) तिमी र उसले के काम गर्‍यौ ।</h5>
        <p>= तिमी र उसले के काम गर्‍यौ ?</p>
        <h5>(ङ) अहा कति सुन्दर जीवन</h5>
        <p>= अहा! कति सुन्दर जीवन ।</p>
        <h5>(च) अग्लो होचो टाढा नजिक वर पर आदि विपरीतार्थी शब्द हुन्</h5>
        <p>अग्लो-होचो , टाढा-नजिक , वर-पर आदि विपरीतार्थी शब्द हुन् ।</p>
        <h5>(छ) म तुरुन्तै फर्किहाल्छु उसले भन्यो</h5>
        <p>= "म तुरुन्तै फर्किहाल्छु ” उसले भन्यो ।</p>
        <h5>(ज) मेरो देशको नाम हो नेपाल</h5>
      <p>= मेरो देशको नाम हो नेपाल।</p>
      <h5>(झ) क्रियाहरुलाई कर्मप्रदानताका आधारमा दुई किसिममा बाँड्न सकिन्छ :</h5>
      <h5>(क) सकर्मक (ख) अकर्मक</h5>
      <p>क्रियाहरुलाई कर्मप्रधानताका आधारमा दुई किसिममा बाँड्न सकिन्छ :-
(क) सकर्मक  (ख) अकर्मक</p>
       <h5>(ञ) उक्ति कथन दुई किसिमका हुन्छन् प्रत्यक्ष र अप्रत्यक्ष कथन</h5>
       <p>= उक्ति कथन दुई किसिमका हुन्छन् - `प्रत्यक्ष र अप्रत्यक्ष कथन ।´</p>
       <h5>(ट) ले बाट द्वारा प्रथम विभक्ति हुन सक्छन्</h5>
       <p>ले , बाट , द्वारा प्रथम विभक्ति हुन सक्छन् ।</p>
       <h5>(ठ) मानिस ठुलो दिलले हुन्छ जातले हुँदैन यो सुक्ति देवकोटाको हो</h5>
       <p>“मानिस ठुलो दिलले हुन्छ , जातले हुँदैन ।” यो सुक्ति देवकोटाको हो ।</p>
       <h5>(ड) हरि तिमी के गर्दै छौ</h5>
       <p>हरि! तिमी के गर्दै छौ ?</p>
      </div>
      <hr/>
      <div>
        <h5>३. उचित लेख्य चिह्नहरु प्रयोग गरी दिइएको अनुच्छेद पुनर्लेखन गर्नुहोस् :</h5>
        <p>ओहो! भोलि त परीक्षाफल प्रकाशित हुने दिन । मेरो जिपिए कति आउने होला ? व्यर्थै परीक्षा आउने बेलामा पनि फुटबल खेल्ने भइटोपलेको । बुबाले त सम्झाउँदै हुनुहुन्थ्यो ,” पढाइ पहिलो कुरा अनिमात्र अरु कुरा आउँछन् ” भनेर तर त्यतिबेला वास्ता गरिएन । राम, हरि, गोपाल र शिवले कर गरेपछि खेल्नै पर्यो । न त फुटबल नै जितियो न त पढाइमा नै ध्यान दिन सकियो तर के नै बिगारेको छु र । ( कोल्टे फेर्दै ) धत! अब चिन्ता गरेर के फाइदा र । ” निर्णय गर्न गल्ती गरे पछुताउनु पर्छ” गुरुले भन्नुभएको थियो । त्यस्तै भएजस्तो छ, खैर जे भयो भयो । अब चाहिँ यस्तो नगर्नुपर्ला । ( बत्ती निभाउँछ र सुत्छ )</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका चिह्नहरु प्रयोग गरी एउटा अनुच्छेद तयार पार्नुहोस् :</h5>
        <p>ओहो! भोलि त परीक्षाफल प्रकाशित हुने दिन । मेरो जिपिए कति आउने होला ? व्यर्थै परीक्षा आउने बेलामा पनि फुटबल खेल्ने भइटोपलेको । बुबाले त सम्झाउँदै हुनुहुन्थ्यो ,” पढाइ पहिलो कुरा अनिमात्र अरु कुरा आउँछन् ” भनेर तर त्यतिबेला वास्ता गरिएन । राम, हरि, गोपाल र शिवले कर गरेपछि खेल्नै पर्यो । न त फुटबल नै जितियो न त पढाइमा नै ध्यान दिन सकियो तर के नै बिगारेको छु र । ( कोल्टे फेर्दै ) धत! अब चिन्ता गरेर के फाइदा र । ” निर्णय गर्न गल्ती गरे पछुताउनु पर्छ” गुरुले भन्नुभएको थियो । त्यस्तै भएजस्तो छ, खैर जे भयो भयो । अब चाहिँ यस्तो नगर्नुपर्ला । ( बत्ती निभाउँछ र सुत्छ )</p>
      </div>
    </div>
  )
}

export default Sathilaichithi
